import React from 'react';
import { useSelector } from 'react-redux';
import { Mui } from '@osu/react-ui';
import ArrowIcon from '@mui/icons-material/ArrowDownward';
import useApplicantMenuOptions from './hooks/useApplicantActions';
import useRoleAuthentication from '../../../Common/hooks/useRoleAuthentication';
import { getStudentState } from '../../../Common/redux/selectors';
import { STATUSES } from '../../../util/constants';

const styles = {
  icon: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    marginRight: '1rem',
    color: theme.palette?.primary?.main || '#1976d2',
  }),
  menuItem: (theme) => ({
    padding: '.7rem 1rem .7rem 1rem',
    borderLeft: `4px solid white`,
    '&:hover': {
      borderLeft: `4px solid ${theme.palette?.primary?.main || '#1976d2'}`,
    },
    minWidth: '16rem',
  }),
  muiList: {
    '& .MuiMenu-list': {
      minWidth: '15rem',
    },
  },
};

const Menu = (props) => {
  const authDetails = useRoleAuthentication();
  const { selectMenuItem, menuAnchorEl, setMenuAnchorEl, isTraining, pageAppHeader } = props;

  const studentData = useSelector((state) => getStudentState(state)).data;
    
  const { assignable, status, isNotifyAdminActive, notifyAdminReviewerEmplids } = useSelector((state) => {
    const studentInfo = getStudentState(state)?.data ?? {};
    const notifyAdminReviewerEmplids = studentInfo?.readers
        ?.filter(reviewer => reviewer.adminAction === STATUSES.NOTIFY)
        ?.map(reviewer => reviewer?.readerEmployeeId);

    return {
      assignable: studentInfo?.demographics?.assignable,
      status: studentInfo?.demographics?.status,
      isNotifyAdminActive: studentInfo?.adminAction === STATUSES.NOTIFY,
      notifyAdminReviewerEmplids
    };
  });

  const isCurrentReviewerNotifyAdmin = (notifyAdminReviewerEmplids ?? []).includes(pageAppHeader?.userId);
  
  const handleClick = (event) => { setMenuAnchorEl(event.currentTarget); };
  const handleClose = () => { setMenuAnchorEl(null); };
  const disableActionMenu = (authDetails.ADMIN !== true && (isTraining || isCurrentReviewerNotifyAdmin)) || status?.includes(STATUSES.CANCELLED);

  const applicantTrainingDoesntExist = !(pageAppHeader.applicantTrainingExists === true);

  const extraInfo = {
    assignable,
    status,
    isNotifyAdminActive,
    isCurrentReviewerNotifyAdmin,
    priority: studentData?.priority,

    applicantTrainingDoesntExist,
    isTraining,
  };
  
  let { menuItems } = useApplicantMenuOptions(extraInfo);

  // console.log("extraInfo, authDetails, isTraining, status, training exists", extraInfo, authDetails, isTraining, status, pageAppHeader.applicantTrainingExists);

  return (
    <React.Fragment>
      <Mui.Button
        startIcon={<ArrowIcon />}
        variant="contained"
        color="primary"
        onClick={handleClick}
        disabled={disableActionMenu}
      >
        Actions
      </Mui.Button>
      <Mui.Menu
        id="applicant-menu"
        sx={styles.muiList}
        anchorEl={menuAnchorEl}
        keepMounted
        open={Boolean(menuAnchorEl)}
        onClose={handleClose}
      >
        {
          menuItems.map(({ type, title, icon }, index) => {
            return (
              <Mui.Box key={`${type}-${index}`}>
                <Mui.MenuItem
                  onClick={() => selectMenuItem({ type })}
                  sx={styles.menuItem}
                >
                  <Mui.Box sx={styles.icon}>{icon}</Mui.Box>
                  <Mui.Box>{title}</Mui.Box>  
                </Mui.MenuItem>
              </Mui.Box>
            );
          })
        }
      </Mui.Menu>
    </React.Fragment>
  );
};

export default Menu;